import { useTranslation } from 'react-i18next'

import { DRAFT_CREATE_ACTION, isDraftOpenAction } from '../../../Draft'
import { RadioGroupModal } from '../../../Radio'
import { QA_NAME_APPLICANT_DRAFT_CREATE_ACTION_MODAL } from '../RentalPortalApplicants.constants'
import { getApplicantDraftFormValues } from '../RentalPortalApplicants.hooks'

import { APPLICANT_DRAFT_CREATE_ACTION_FIELD_NAME } from './RentalPortalApplicantDraftCreateActionSelectModal.constants'
import {
  getApplicantDraftCreateActionOptions,
  getApplicantDraftListingLabel,
  getApplicantDraftSavedAtLabel,
} from './RentalPortalApplicantDraftCreateActionSelectModal.utils'

import * as styles from './RentalPortalApplicantDraftCreateActionSelectModal.module.css'

function RentalPortalApplicantDraftCreateActionSelectModal({
  draft,
  initialValues,
  onCancel,
  onSubmit,
}) {
  const { t } = useTranslation()

  function getOptions() {
    return getApplicantDraftCreateActionOptions({
      listingLabel: getApplicantDraftListingLabel(draft),
      listingLabelClassName: styles.listingLabel,
      savedAtClassName: styles.savedAt,
      savedAtLabel: getApplicantDraftSavedAtLabel(draft),
      t,
    })
  }

  function handleSubmit({
    [APPLICANT_DRAFT_CREATE_ACTION_FIELD_NAME]: action,
  }) {
    onSubmit?.({
      action,
      initialValues: isDraftOpenAction(action)
        ? getApplicantDraftFormValues(draft)
        : initialValues,
    })
  }

  return (
    <RadioGroupModal
      formFieldsProps={{
        getOptions,
        name: APPLICANT_DRAFT_CREATE_ACTION_FIELD_NAME,
        radioComponentProps: {
          labelProps: { className: styles.optionLabel },
        },
        submitProps: { title: 'Modal.ContinueBtnKey' },
        title: t('RentalPortal.ListingDraftCreateActionTitleKey'),
      }}
      initialValues={{
        [APPLICANT_DRAFT_CREATE_ACTION_FIELD_NAME]:
          DRAFT_CREATE_ACTION.openDraft,
      }}
      qaName={QA_NAME_APPLICANT_DRAFT_CREATE_ACTION_MODAL}
      title={t('RentalPortal.ListingDraftCreateModalTitleKey')}
      onCancel={onCancel}
      onClose={onCancel}
      onSubmit={handleSubmit}
    />
  )
}

export default RentalPortalApplicantDraftCreateActionSelectModal
